import { createPortal } from 'react-dom'
import { KTSVG } from '_metronic/helpers'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import useViewModel, { Props } from './ViewModel'

const SurveyAssignSales: React.FC<Props> = props => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  const {
    isOpen,
    isSubmitting,
    saleUserOptions,
    selectedSaleUsers,
    onClose,
    onChangeSaleUsers,
    onSubmit,
  } = useViewModel(props)

  return createPortal(
    <Modal
      id='kt_modal_project_import'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={isOpen}
      onHide={onClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>แก้ไขผู้ขาย</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-200px'>
          <div className='row gy-3'>
            <div className='col-12'>
              <label htmlFor='sellerId' className='fs-6 mb-1 fw-bold'>
                ผู้ขาย
              </label>

              <Select
                isMulti
                isClearable
                options={saleUserOptions}
                value={saleUserOptions.filter(option =>
                  selectedSaleUsers.map(su => su.id).includes(option.value)
                )}
                onChange={(selectedOptions: any) => {
                  onChangeSaleUsers(selectedOptions)
                }}
                isDisabled={isSubmitting}
                placeholder='เลือกผู้ขาย'
                components={{ IndicatorSeparator: () => null }}
              />
            </div>
          </div>
        </div>

        <div className='modal-footer'>
          <div className='col-12 d-flex flex-row justify-content-end' style={{ columnGap: '12px' }}>
            <button
              type='reset'
              className='btn btn-sm btn-light fw-bolder'
              onClick={onClose}
              disabled={isSubmitting}>
              ยกเลิก
            </button>
            <button
              type='submit'
              className='btn btn-sm btn-success me-4 fw-bold'
              onClick={onSubmit}
              disabled={isSubmitting}>
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default SurveyAssignSales
